import { useCallback } from "react";
import { reducesConsultsLeft } from "../../../utils/apis/booking-service";
import { ErrorWithMessageCallback } from "../../../utils/apis/callback-helpers";
import { useAuth } from "../../../utils/context/AuthContext";
import { ConsultType } from "../../../utils/Enums";

export function useReduceConsultsLeft() {
    const { auth } = useAuth()
    const idToken =auth.idToken

    return useCallback(
        (
            user_id: string,
            consult_type: ConsultType,
            onSuccess: (left: number) => void,
            onError: ErrorWithMessageCallback
        ) => {
            if (!idToken) {
                onError("Token mancante");
                return;
            }
            reducesConsultsLeft(user_id, idToken, consult_type, onSuccess, onError);
        },
        [idToken]
    );
}